import { AuthService } from './../../../shared/services/auth.service';
import { IConfirmEmail } from '../../../_models/Account/user';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html'
})
export class ConfirmEmailComponent implements OnInit {

  loading: boolean;
  confirmEmail: IConfirmEmail = {
    code: '',
    userId: ''
  };
  code: string;
  confirm: boolean = false;
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute) {
    this.route.queryParams
      .subscribe(params => {
        this.confirmEmail.userId = params.userId;
        this.confirmEmail.code = params.code;
        this.postConfirmEmail();
      });
  }

  ngOnInit() {

  }

  postConfirmEmail() {
    this.authService.confirmEmail(this.confirmEmail).subscribe((response: any) => {
      console.log(response);
      if (response) {
        this.confirm = true;
      }
    },
      (error) => console.log('HTTP Error', error),
      () => this.loading = false
    );
  }
}
